var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9057 1.52355C12.9317 1.50907 12.9643 1.5 13.0004 1.5C13.0365 1.5 13.069 1.50907 13.095 1.52355C13.1175 1.53604 13.1473 1.55889 13.1771 1.60969L23.4626 19.1097C23.5161 19.2007 23.515 19.296 23.4658 19.3847C23.4411 19.4292 23.4102 19.4585 23.3837 19.475C23.3616 19.4887 23.3331 19.5 23.2858 19.5H2.71493C2.6676 19.5 2.63911 19.4887 2.61703 19.475C2.59049 19.4585 2.55963 19.4292 2.53496 19.3847C2.48575 19.296 2.48467 19.2007 2.53817 19.1097L12.8236 1.60969C12.8535 1.55889 12.8832 1.53604 12.9057 1.52355ZM14.4703 0.849632C13.8045 -0.283211 12.1962 -0.283211 11.5304 0.849632L1.24499 18.3496C0.559436 19.5161 1.38246 21 2.71493 21H23.2858C24.6183 21 25.4413 19.5161 24.7557 18.3496L14.4703 0.849632Z",
    fill: "#FFBB0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5004 16.5C11.5004 15.6716 12.1719 15 13.0004 15C13.8288 15 14.5004 15.6716 14.5004 16.5C14.5004 17.3284 13.8288 18 13.0004 18C12.1719 18 11.5004 17.3284 11.5004 16.5Z",
    fill: "#FFBB0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6473 7.49256C11.5674 6.69343 12.1949 6 12.998 6C13.8012 6 14.4287 6.69343 14.3488 7.49256L13.8227 12.7537C13.7803 13.1774 13.4238 13.5 12.998 13.5C12.5723 13.5 12.2158 13.1774 12.1734 12.7537L11.6473 7.49256Z",
    fill: "#FFBB0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.aecb022cb76a2dc9b06db6a20990e989.svg";
export { ForwardRef as ReactComponent };